import React from 'react';
import PropTypes from 'prop-types';
import { Flex, Text } from '@chakra-ui/react';
import { palette, Icon } from '@m12s/component-library';
import { falTimes } from 'lib/icons';
import { IconWrapper } from 'components/SwipeUpModal';

export const DRAWER_HEADER_MIN_HEIGHT = '48px';
export const DRAWER_TOOLBAR_HEADER_MIN_HEIGHT = '72px';

export const drawerHeaderTitleStyles = {
  fontFamily: "'Noto Sans', sans-serif",
  fontSize: '20px',
  fontWeight: 500,
  lineHeight: '24px',
  color: palette.Grey700,
  letterSpacing: '0.1px',
};

/**
 * Shared flyup drawer header chrome — title slot, optional actions slot, close button.
 * Matches SwipeUpModal header styling. Used by MMDrawer (host) and exported for parity.
 */
const DrawerHeaderBar = ({
  title,
  onClose,
  actions,
  headerLeft,
  closeAriaLabel = 'Close',
  toolbar = false,
}) => {
  const minHeight = toolbar
    ? DRAWER_TOOLBAR_HEADER_MIN_HEIGHT
    : DRAWER_HEADER_MIN_HEIGHT;

  const closeInFlow = Boolean(actions);

  return (
    <Flex
      as="header"
      align="center"
      bg={palette.White}
      borderBottom={`1px solid ${palette.Grey400}`}
      flexShrink={0}
      gap="0.75rem"
      minH={minHeight}
      pl="16px"
      pr="8px"
      py="12px"
      position="relative"
    >
      {headerLeft}

      {title != null &&
        title !== '' &&
        (typeof title === 'string' ? (
          <Text
            {...drawerHeaderTitleStyles}
            flex={1}
            minW={0}
            overflow="hidden"
            textOverflow="ellipsis"
            whiteSpace="nowrap"
            mr={!closeInFlow && onClose ? '3rem' : 0}
          >
            {title}
          </Text>
        ) : (
          <Flex flex={1} minW={0} mr={!closeInFlow && onClose ? '3rem' : 0}>
            {title}
          </Flex>
        ))}

      {actions && (
        <Flex
          align="center"
          flex={title == null || title === '' ? 1 : '0 0 auto'}
          gap="0.75rem"
          minW={0}
        >
          {actions}
        </Flex>
      )}

      {onClose && closeInFlow && (
        <IconWrapper
          type="button"
          aria-label={closeAriaLabel}
          onClick={onClose}
          style={{
            flexShrink: 0,
            marginLeft: 'auto',
          }}
        >
          <Icon
            size="2rem"
            color={palette.Grey700}
            icon={falTimes}
            cursor="pointer"
          />
        </IconWrapper>
      )}

      {onClose && !closeInFlow && (
        <IconWrapper
          type="button"
          aria-label={closeAriaLabel}
          onClick={onClose}
          style={{
            position: 'absolute',
            top: '50%',
            right: '1.5rem',
            transform: 'translateY(-50%)',
            zIndex: 1,
          }}
        >
          <Icon
            size="2rem"
            color={palette.Grey700}
            icon={falTimes}
            cursor="pointer"
          />
        </IconWrapper>
      )}
    </Flex>
  );
};

DrawerHeaderBar.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  onClose: PropTypes.func,
  actions: PropTypes.node,
  headerLeft: PropTypes.node,
  closeAriaLabel: PropTypes.string,
  toolbar: PropTypes.bool,
};

export default DrawerHeaderBar;
